import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Style from "./error-styles";
import errorImage from "../../../assets/images/error.png";
import { Button } from "@mui/material";

import { clearAllCookies } from "../../../utils/cookie.util";

export default function MsalError() {
    const classes = Style();

    const handleRemoveCookiesAndRedirect = () => {
        clearAllCookies();
        const msalURL = localStorage.getItem('msal_web_url');
        localStorage.removeItem('msal_web_url');
        window.location.href = msalURL || '/';
    }

    return (
        <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.root}
        >
            <Grid item xs className={classes.content}>
                <img
                    src={errorImage}
                    alt="Ocorreu um erro ao tentar executar a sua solicitação."
                />
                <Typography variant="h1" gutterBottom>
                    Que pena!
                </Typography>
                <Typography variant="h4" gutterBottom>
                    Ocorreu um erro ao tentar executar a sua solicitação.
                </Typography>
                <Typography variant="h5">Por favor, limpe os dados da sua sessão e tente novamente!</Typography>
                <Button
                    variant="contained"
                    color="secondary"
                    className={classes.buttonFooter}
                    onClick={handleRemoveCookiesAndRedirect}
                >
                    TENTAR NOVAMENTE
                </Button>
            </Grid>
        </Grid>
    );
}
